import * as React from "react";
import { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  Keyboard,
  View,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { FontAwesome } from "@expo/vector-icons";
import { backendUrl } from "../constants/Environment.js";
import { useAuthDispatch } from "../context/Index.js";
import NavbarDesktop from "../components/NavbarDesktop.js";
import { MonoText } from "../components/StyledText.js";

export default function ChangePasswordScreen({
  setLoggedIn,
  setAuthToken,
  showNavBar,
  userId,
  navigation: { goBack, navigate, setParams },
}) {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [statusText, setStatusText] = useState("");
  const [passwordChangeSuccess, setPasswordChangeSuccess] = useState(false);
  const window = useWindowDimensions();

  const dispatch = useAuthDispatch();

  function validateForm() {
    if (!password || !newPassword || !confirmPassword) {
      setStatusText("Please fill out the form");
      return false;
    }
    return newPassword.length > 0 && confirmPassword.length > 0;
  }

  async function signUp(event) {
    if (!validateForm()) {
      return;
    }
    if (newPassword !== confirmPassword) {
      setStatusText("New password and confirm password doesn't match");
      return;
    }
    fetch(`${backendUrl}/changepassword/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        userId: userId,
        currentPassword: password,
        newPassword: newPassword,
      }),
    })
      .then(async (response) => {
        if (response.ok || response.status == 200) {
          setStatusText("Password changed successfully.");
          setPasswordChangeSuccess(true);
        } else {
          setStatusText("Invalid password");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  var styleDynamic = StyleSheet.create({
    container: {
      textShadowColor: "#585858",
      textShadowOffset: { width: 5, height: 5 },
      textShadowRadius: 10,
      alignItems: window.width > 900 ? "center" : "stretch",
      marginTop: 10,
      marginBottom: 0,
    },
    nextContainer: {
      marginBottom: 32,
      marginTop: 0,
      alignItems: window.width > 900 ? "center" : "stretch",
      minHeight: 600,
      flex: 1,
      paddingTop: 30,
      flexGrow: 1,
    },
  });

  return (
    <ScrollView
      style={{
        backgroundColor: "#fff",
      }}
    >

      <View pointerEvents="box-none" style={{ elevation: 2, zIndex: 2, }}>
        <NavbarDesktop
          goBack={goBack}
          navigate={navigate}
          setParams={setParams}
        />
      </View>
      <TouchableOpacity style={styleDynamic.container} activeOpacity={1}>
        <View style={styleDynamic.nextContainer}>
          <KeyboardAvoidingView
            behavior={Platform.OS == "ios" ? "padding" : "height"}
            style={newStyles.container}
          >
            <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
              <ScrollView
                style={newStyles.container}
                contentContainerStyle={styles.contentContainer}
              >
                <View style={newStyles.inner}>
                  <Image
                    source={require("../assets/images/robot-dev.png")}
                    style={styles.welcomeImage}
                  />
                  <Text style={newStyles.header}>Change Password</Text>

                  {passwordChangeSuccess ? (
                    <>
                      {statusText && (
                        <MonoText style={{ color: "green" }}>
                          {statusText}
                        </MonoText>
                      )}
                      <FontAwesome.Button
                        onPress={(e) => {
                          setStatusText("");
                          setPassword("");
                          setNewPassword("");
                          setConfirmPassword("");
                          goBack();
                        }}
                        style={styles.loginButtonStyle}
                        backgroundColor="#018c14"
                        fontSize="2x"
                      >
                        <Text style={{ color: "#fff" }}>Back</Text>
                      </FontAwesome.Button>
                    </>
                  ) : (
                    <View>
                      <TextInput
                        placeholder="Current password"
                        placeholderColor="#c4c3cb"
                        style={newStyles.textInput}
                        onChangeText={(e) => {
                          setStatusText("");
                          setPassword(e);
                        }}
                        onChanged={(e) => {
                          setStatusText("");
                          setPassword(e.target.value);
                        }}
                      />
                      <TextInput
                        placeholder="New Password"
                        placeholderColor="#c4c3cb"
                        style={newStyles.textInput}
                        secureTextEntry={true}
                        onChangeText={(e) => {
                          setStatusText("");
                          setNewPassword(e);
                        }}
                        onChange={(e) => {
                          setStatusText("");
                          setNewPassword(e.target.value);
                        }}
                      />
                      <TextInput
                        placeholder="Confirm New Password"
                        placeholderColor="#c4c3cb"
                        style={newStyles.textInput}
                        secureTextEntry={true}
                        onChangeText={(e) => {
                          setStatusText("");
                          setConfirmPassword(e);
                        }}
                        onChange={(e) => {
                          setStatusText("");
                          setConfirmPassword(e.target.value);
                        }}
                      />
                      {statusText && (
                        <MonoText style={{ color: "red" }}>
                          {statusText}
                        </MonoText>
                      )}

                      <FontAwesome.Button
                        onPress={(e) => signUp(e)}
                        style={styles.loginButtonStyle}
                        backgroundColor="#018c14"
                        fontSize="2x"
                      >
                        <Text style={{ color: "#fff" }}>Continue</Text>
                      </FontAwesome.Button>
                    </View>
                  )}
                </View>
              </ScrollView>
            </TouchableWithoutFeedback>
          </KeyboardAvoidingView>
        </View>
      </TouchableOpacity>
    </ScrollView>
  );
}

ChangePasswordScreen.navigationOptions = {
  header: null,
};

const newStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  viewItem: {
    flex: 2,
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 24,
    paddingBottom: 24,
  },
  inner: {
    padding: 24,
    flex: 1,
    justifyContent: "space-around",
  },
  header: {
    fontSize: 36,
    marginBottom: 48,
  },
  textInput: {
    height: 40,
    borderColor: "#000000",
    borderBottomWidth: 1,
    marginBottom: 36,
  },
  btnContainer: {
    backgroundColor: "white",
    marginTop: 12,
  },
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  contentContainer: {
    paddingTop: 30,
  },
  welcomeImage: {
    width: 100,
    height: 80,
    resizeMode: "contain",
    marginTop: 3,
    marginLeft: -10,
  },
  loginButtonStyle: {
    color: "#fff",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  textAlreadyHasAccount: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    paddingTop: 16,
  },
});
